import Vue from 'vue'
import VueRouter from 'vue-router'
// vue-cookies配置
import VueCookies from 'vue-cookies'
import store from '@/store/index.js'

const UniLogin = () => import('../views/login/UniLogin')
const Login = () => import('../views/login/Login')
const Index = () => import('../views/index/Index')
const Home = () => import('../views/home/Home')
const Personal = () => import('../views/personal/Personal')
const OrgPersonal = () => import('../views/personal/OrgPersonal')
const PasswordSetting = () => import('../views/personal/PasswordSetting')
// * 系统管理
// 系统账号管理
const SystemAccountList = () => import('../views/system/system_account/SystemAccountList')
const AddOrEditSystemAccount = () => import('../views/system/system_account/childComps/AddOrEditSystemAccount')
// 机构账号管理
const OrgAccountList = () => import('../views/system/org_account/OrgAccountList')
const AddOrEditOrgAccount = () => import('../views/system/org_account/childComps/AddOrEditOrgAccount')

const MenuList = () => import('../views/system/menu_management/MenuList')
const RoleList = () => import('../views/system/role_management/RoleList')
const AddOrEditSystemRole = () => import('../views/system/role_management/childComps/AddOrEditSystemRole')
const SystemLogList = () => import('../views/system/log_management/SystemLogList')

//企业端-机构管理
const CorporateList = () => import('../views/enterprise/orgManage/CorporateList')
const AddOrEditOrg = () => import('../views/enterprise/orgManage/childComps/AddOrEditOrg')
const ContractInfo = () => import('../views/enterprise/orgManage/ContractInfo')
const AddOrEditContract = () => import('../views/enterprise/orgManage/childComps/AddOrEditContract')
const SettleRecord = () => import('../views/enterprise/orgManage/SettleRecord')
const AddOrEditSettle = () => import('../views/enterprise/orgManage/childComps/AddOrEditSettle')

// 企业端-资源管理
const ResourceList = () => import('../views/enterprise/resourceManage/ResourceList')
const AddOrEditResource = () => import('../views/enterprise/resourceManage/childComps/AddOrEditResource')
const ResourceDataStat = () => import('../views/enterprise/resourceManage/ResourceDataStat')
const BatchImport = () => import('../views/enterprise/resourceManage/childComps/BatchImport')

// 企业端-产品管理
const ProductConfig = () => import('../views/enterprise/productManage/ProductConfig')

//机构端
const OrgContractInfo = () => import('../views/org/ContractInfo')
const OrgResourceData = () => import('../views/org/ResourceData')
const OrgSettleRecord = () => import('../views/org/SettleRecord')

Vue.use(VueRouter)

const routes = [
    {
        path: '',
        redirect: '/index'
    },
    {
        path: '/uni_login',
        name: 'UniLogin',
        component: UniLogin
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/index',
        name: 'Index',
        component: Index,
        redirect: '/home',
        children: [
            {
                path: '/home',
                name: 'Home',
                component: Home,
                children: [
                    // todo：系统管理
                    {
                        path: '/sys_account_list',
                        name: 'SystemAccountList',
                        component: SystemAccountList,
                        meta: { title: '系统账号管理', breadcrumb: true }
                    },
                    {
                        path: '/account_list/addoredit_systemaccount',
                        name: 'AddOrEditSystemAccount',
                        component: AddOrEditSystemAccount,
                        meta: { title: '添加/修改系统账号' }
                    },
                    {
                        path: '/org_account_list',
                        name: 'OrgAccountList',
                        component: OrgAccountList,
                        meta: { title: '机构账号管理', breadcrumb: true }
                    },
                    {
                        path: '/addoredit_orgaccount',
                        name: 'AddOrEditOrgAccount',
                        component: AddOrEditOrgAccount,
                        meta: { title: '添加/修改机构账号' }
                    },
                    {
                        path: '/menu_list',
                        name: 'MenuList',
                        component: MenuList,
                        meta: { title: '菜单管理', breadcrumb: true }
                    },
                    {
                        path: '/role_list',
                        name: 'RoleList',
                        component: RoleList,
                        meta: { title: '角色管理', breadcrumb: true }
                    },
                    {
                        path: '/role_list/addoredit_system_role',
                        name: 'AddOrEditSystemRole',
                        component: AddOrEditSystemRole,
                        meta: { title: '角色管理' }
                    },
                    {
                        path: '/log_list',
                        name: 'SystemLogList',
                        component: SystemLogList,
                        meta: { title: '日志管理', breadcrumb: true }
                    },
                    //企业端
                    {
                        path: '/corporate_list',
                        name: 'CorporateList',
                        component: CorporateList,
                        meta: { title: '机构管理', breadcrumb: true }
                    },
                    {
                        path: '/addoredit_org',
                        name: 'AddOrEditOrg',
                        component: AddOrEditOrg,
                        meta: { title: '添加/修改机构' }
                    },
                    {
                        path: '/contract_info',
                        name: 'ContractInfo',
                        component: ContractInfo,
                        meta: { title: '合同信息', breadcrumb: true }
                    },
                    {
                        path: '/addoredit_contract',
                        name: 'AddOrEditContract',
                        component: AddOrEditContract,
                        meta: { title: '添加/修改合同' }
                    },
                    {
                        path: '/settle_record',
                        name: 'SettleRecord',
                        component: SettleRecord,
                        meta: { title: '结算记录', breadcrumb: true }
                    },
                    {
                        path: '/addoredit_settle',
                        name: 'AddOrEditSettle',
                        component: AddOrEditSettle,
                        meta: { title: '添加/修改结算记录' }
                    },
                    {
                        path: '/resource_list',
                        name: 'ResourceList',
                        component: ResourceList,
                        meta: { title: '资源管理', breadcrumb: true }
                    },
                    {
                        path: '/addoredit_resource',
                        name: 'AddOrEditResource',
                        component: AddOrEditResource,
                        meta: { title: '添加/修改资源' }
                    },
                    {
                        path: '/batch_import',
                        name: 'BatchImport',
                        component: BatchImport,
                        meta: { title: '批量导入', breadcrumb: true }
                    },
                    {
                        path: '/resource_data_stat',
                        name: 'ResourceDataStat',
                        component: ResourceDataStat,
                        meta: { title: '资源数据统计', breadcrumb: true }
                    },
                    {
                        path: '/product_config',
                        name: 'ProductConfig',
                        component: ProductConfig,
                        meta: { title: '产品配置', breadcrumb: true }
                    },
                    //机构端
                    {
                        path: '/org_contract_info',
                        name: 'OrgContractInfo',
                        component: OrgContractInfo,
                        meta: { title: '合同信息', breadcrumb: true }
                    },
                    {
                        path: '/org_resource_data',
                        name: 'OrgResourceData',
                        component: OrgResourceData,
                        meta: { title: '资源数据', breadcrumb: true }
                    },
                    {
                        path: '/org_settle_record',
                        name: 'OrgSettleRecord',
                        component: OrgSettleRecord,
                        meta: { title: '结算记录', breadcrumb: true }
                    }
                ]
            },

            {
                path: '/personal',
                name: 'Personal',
                component: Personal,
                meta: { title: '个人资料' }
            },
            {
                path: '/org_personal',
                name: 'OrgPersonal',
                component: OrgPersonal,
                meta: { title: '个人资料' }
            },
            {
                path: '/password_setting',
                name: 'PasswordSetting',
                component: PasswordSetting,
                meta: { title: '修改密码' }
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err)
}

//挂载路由导航守卫
router.beforeEach((to, form, next) => {
    let routerList = ['/uni_login']
    routerList.map((item) => {
        if (item == to.path) {
            store.commit('changeActiveIndex', '')
            VueCookies.set('activeIndex', '')
        }
    })
    // 如果要访问的是登录页则直接放行
    if (to.path == '/login' || to.path == '/uni_login') return next()
    // 获取token
    const tokenStr = VueCookies.get('token')
    // 如果没有token则代表当前尚未登录，强制跳转到登录页
    if (!tokenStr) return next('/login')
    // 如果没有被强制跳转到登录页，则放行到目标页
    next()
})

export default router
